import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useTheme } from '../../theming/contexts/ThemeContext';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module '../.... Remove this comment to see the full error message
import { PrimaryMessageContentSectionWrapper } from './PrimaryMessageContentSection';
import { useAccessibilityContext } from '../../accessibility/AccessibilityContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const PrimaryMessageContentWrapper = styled.div.withConfig({
  displayName: "PrimaryMessageContent__PrimaryMessageContentWrapper",
  componentId: "sc-6al07d-0"
})(["position:relative;min-height:32px;word-break:break-word;box-sizing:border-box;border-style:solid;border-width:", ";border-color:", ";background-color:", ";color:", ";display:inline-flex;align-items:center;flex-direction:column;border-radius:", ";", "{border-top-style:solid;border-top-width:1px;border-top-color:", ";&:first-child{border-top:none;}}max-width:284px;"], ({
  borderWidth
}) => borderWidth, ({
  borderColor
}) => borderColor, ({
  backgroundColor
}) => backgroundColor, ({
  textColor
}) => textColor, ({
  borderRadius
}) => borderRadius, PrimaryMessageContentSectionWrapper, ({
  borderColor
}) => borderColor);
// max-width is for IE (376px-92px)

const PrimaryMessageContent = props => {
  const {
    children,
    className,
    shouldFocusMessage
  } = props;
  const theme = useTheme();
  const {
    backgroundColor,
    borderColor,
    borderRadius,
    borderWidth,
    textColor
  } = theme;
  const ref = useRef(null);
  const {
    disableAutoFocus
  } = useAccessibilityContext();
  useEffect(() => {
    if (!disableAutoFocus && shouldFocusMessage && ref.current) {
      ref.current.focus();
    }
  }, [disableAutoFocus, shouldFocusMessage]);
  return /*#__PURE__*/_jsx(PrimaryMessageContentWrapper, {
    className: className,
    backgroundColor: backgroundColor,
    borderColor: borderColor,
    borderRadius: borderRadius,
    borderWidth: borderWidth,
    tabIndex: 0,
    ref: ref,
    textColor: textColor,
    "data-test-id": "primary-message-content-wrapper",
    children: children
  });
};
PrimaryMessageContent.displayName = 'PrimaryMessageContent';
PrimaryMessageContent.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  shouldFocusMessage: PropTypes.bool
};
export default PrimaryMessageContent;